






import { Component, Vue, Prop } from 'vue-property-decorator';
import CalendarEventData from '@/ts/CalendarEventData';

@Component
export default class CalendarEvent extends Vue {
    @Prop() public calendarEventData!: CalendarEventData;

    constructor() {
        super();
    }

    get eventClass(): object {
        return {
            'hococo-calendar-event__important': this.calendarEventData.isImportant,
            'hococo-calendar-event__unclassified': !this.calendarEventData.isImportant,
        };
    }
}
